import { getHistory } from '../routing/history';
import { isAnalytics, isError, isPerformance, LogCategory } from './log.types';
var LogLevel;
(function (LogLevel) {
    LogLevel[LogLevel["Trace"] = 0] = "Trace";
    LogLevel[LogLevel["Info"] = 1] = "Info";
    LogLevel[LogLevel["Comment"] = 2] = "Comment";
    LogLevel[LogLevel["Warning"] = 3] = "Warning";
    LogLevel[LogLevel["Error"] = 4] = "Error";
    LogLevel[LogLevel["Critical"] = 5] = "Critical";
})(LogLevel || (LogLevel = {}));
var loggingQueueLocked = true;
export function makeMacKustoLogger(appIdStr, kustoEndpointStr, hostNameStr, versionInfoStr) {
    var loggingQueueInterval = 1000;
    var queue = [];
    var remoteLoggerSequenceNumber = 0;
    var appId = appIdStr;
    var kustoEndpoint = kustoEndpointStr;
    var hostName = hostNameStr;
    var versionInfo = versionInfoStr;
    /**
     * Type confirms with server-side contract
     */
    /**
     * Http request used exclusively for talking with /api/instrument
     */
    var sendInstrumentRequest = function () {
        if (queue.length === 0 || loggingQueueLocked) {
            setTimeout(sendInstrumentRequest, loggingQueueInterval);
            return;
        }
        // TODO: sendBeacon() is broken right now in Chrome:
        // http://crbug.com/490015
        var req = new XMLHttpRequest();
        req.open('POST', kustoEndpoint, true);
        req.setRequestHeader('Content-Type', 'application/json');
        // Set common headers
        req.setRequestHeader('x-ms-mac-hostingapp', hostName);
        req.setRequestHeader('x-ms-mac-appid', appId);
        req.setRequestHeader('x-ms-mac-version', versionInfo);
        req.onreadystatechange = function () {
            if (req.readyState === XMLHttpRequest.DONE) {
                if (req.status !== 204) {
                    console.log("Request to /api/instrument/logclient failed, server responseCode: " + req.status + " body: " + req.response);
                }
                setTimeout(sendInstrumentRequest, loggingQueueInterval);
            }
        };
        var data = queue.splice(0, queue.length);
        req.send(JSON.stringify(data));
    };
    setTimeout(sendInstrumentRequest, loggingQueueInterval);
    var queueLog = function (data) {
        queue.push(data);
    };
    function macKustoLogger(options) {
        // only log anything that is not analytics and perf
        if (isAnalytics(options) || isPerformance(options)) {
            return;
        }
        remoteLoggerSequenceNumber += 1;
        var tagId = parseInt(options.id, 10);
        var message = options.message || '';
        var pathName = '', flyoutName = '';
        try {
            pathName = getHistory().location.pathname;
            if (pathName !== null && pathName.indexOf(':') !== -1) {
                var pathArray = pathName.split(':');
                pathName = pathArray[0];
                flyoutName = pathArray[1];
            }
        }
        catch (error) {
            pathName = '';
            flyoutName = '';
        }
        queueLog({
            TagId: tagId,
            LogLevel: LogLevel.Info,
            LogCategory: options.logCategory || LogCategory.ClientInfo,
            Message: message,
            Adhoc0: appId,
            Adhoc1: remoteLoggerSequenceNumber.toString(),
            Adhoc2: JSON.stringify({
                data: options.data
            }),
            Adhoc5: flyoutName,
            PageName: pathName
        });
        if (isError(options)) {
            var stack = options.error.stack || '';
            // log the stack under 500781
            queueLog({
                TagId: 500781,
                LogLevel: LogLevel.Error,
                LogCategory: options.logCategory || LogCategory.ClientError,
                Message: "UI Exception: " + (options.error.message || ''),
                Adhoc0: appId,
                Adhoc1: remoteLoggerSequenceNumber.toString(),
                Adhoc2: JSON.stringify({
                    version: versionInfo,
                    stack: stack
                }),
                Adhoc3: tagId.toString(),
                Adhoc5: flyoutName,
                PageName: pathName
            });
        }
    }
    return macKustoLogger;
}
export function unlockLoggingQueue() {
    loggingQueueLocked = false;
}
